var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8703 2.41713C21.6139 1.4657 20.8583 0.716374 19.899 0.46208C18.1602 0 11.1877 0 11.1877 0C11.1877 0 4.21517 0 2.47629 0.46208C1.51697 0.716414 0.76142 1.4657 0.504984 2.41713C0.0390625 4.14167 0.0390625 7.73975 0.0390625 7.73975C0.0390625 7.73975 0.0390625 11.3378 0.504984 13.0624C0.76142 14.0138 1.51697 14.7319 2.47629 14.9862C4.21517 15.4483 11.1877 15.4483 11.1877 15.4483C11.1877 15.4483 18.1601 15.4483 19.899 14.9862C20.8583 14.7319 21.6139 14.0138 21.8703 13.0624C22.3362 11.3378 22.3362 7.73975 22.3362 7.73975C22.3362 7.73975 22.3362 4.14167 21.8703 2.41713ZM8.90724 11.0065V4.47296L14.7349 7.73983L8.90724 11.0065Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.df66d193f42501501e027f42c6533917.svg";
export { ForwardRef as ReactComponent };